import SchoolCalendarPage from "../components/pages/SchoolCalendar";

export default SchoolCalendarPage;
